if (!customElements.get('recently-viewed')) {
  const STORAGE_KEY = 'tp-recently-viewed';
  const MAX_STORED = 12;
  const HANDLE_PATTERN = /^[a-z0-9][a-z0-9-]{0,254}$/i;

  customElements.define(
    'recently-viewed',
    class RecentlyViewed extends HTMLElement {
      connectedCallback() {
        this.rememberCurrent();
        this.render();
      }

      get storage() {
        try {
          const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
          return Array.isArray(items) ? items : [];
        } catch (error) {
          return [];
        }
      }

      set storage(items) {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, MAX_STORED)));
      }

      rememberCurrent() {
        const id = this.dataset.productId;
        const handle = this.dataset.productHandle;
        if (!id || !HANDLE_PATTERN.test(handle || '')) return;

        const items = this.storage.filter(
          (item) => String(item.id) !== String(id) && item.handle !== handle
        );
        items.unshift({ id, handle });
        this.storage = items;
      }

      async render() {
        const currentId = this.dataset.productId;
        const limit = Number(this.dataset.limit) || 5;
        const handles = this.storage
          .filter((item) => String(item.id) !== String(currentId) && HANDLE_PATTERN.test(item.handle || ''))
          .slice(0, limit)
          .map((item) => item.handle);

        if (!handles.length) return;

        const root = window.Shopify?.routes?.root || '/';
        const cards = await Promise.all(
          handles.map((handle) =>
            fetch(`${root}products/${handle}?view=recently-viewed-card`)
              .then((response) => (response.ok ? response.text() : ''))
              .then((html) => {
                if (!html) return '';
                const doc = new DOMParser().parseFromString(html, 'text/html');
                const item = doc.querySelector('li.grid__item');
                return item ? item.outerHTML : '';
              })
              .catch(() => '')
          )
        );

        const markup = cards.join('').trim();
        if (!markup) return;

        const grid = this.querySelector('[data-recently-viewed-grid]');
        if (!grid) return;

        grid.innerHTML = markup;
        this.removeAttribute('hidden');
      }
    }
  );
}
